import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiUser, FiGlobe, FiTag, FiDollarSign } from 'react-icons/fi';

const filterIcons = [
  { name: 'alias', icon: <FiTag />, placeholder: 'Vault Alias' },
  { name: 'user', icon: <FiUser />, placeholder: 'User' },
  { name: 'currency', icon: <FiDollarSign />, placeholder: 'Currency' },
  { name: 'country', icon: <FiGlobe />, placeholder: 'Country' },
];

export const VaultFiltersAnimated = ({ filters, setFilters }) => {
  const [activeFilter, setActiveFilter] = useState(null);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const closeFilter = () => setActiveFilter(null);

  return (
    <div className="w-full flex items-center space-x-4 justify-start mb-6">
      <label className="text-white/60 text-sm">Filters</label>

      <div className="flex items-center gap-3 relative">
        {filterIcons.map((filter) => (
          <motion.button
            key={filter.name}
            onClick={() => setActiveFilter(filter.name)}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className={`w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white text-lg hover:bg-white/20 transition ${
              activeFilter === filter.name ? 'ring-2 ring-cyan-400' : ''
            }`}
          >
            {filter.icon}
          </motion.button>
        ))}

        <AnimatePresence>
          {activeFilter && (
            <motion.div
              key="filter-input"
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              className="absolute right-[-16rem]  flex items-center bg-white/5 border border-white/10 backdrop-blur-md px-4 py-2 rounded-xl ml-3"
            >
              <input
                type="text"
                name={activeFilter}
                value={filters[activeFilter]}
                onChange={handleFilterChange}
                placeholder={`Filter by ${
                  filterIcons.find((f) => f.name === activeFilter)?.placeholder
                }`}
                className="bg-transparent text-white text-sm focus:outline-none placeholder-white/40 w-48"
              />
              <button
                onClick={closeFilter}
                className="ml-3 text-white/50 hover:text-white"
              >
                <FiX size={16} />
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
